module.exports = __webpack_public_path__ + "media/images/teaser-icon-woman-border-73aa831e939c2a7e6d7b5938459b025b.svg";